import { formatPrice } from '@ynap/intl-formatters'
import { priceFromPriceObj } from '@ynap/price-utils'
import { EmptyObject, Price, ShoppingCart } from 'app/types/common-types'
import { StoreState } from 'app/state/types'

interface State extends StoreState {
    cart?: ShoppingCart | EmptyObject
}

type StoreCredit = {
    amount: number,
    divisor: number,
    formattedAmount: string
}

export default function getStoreCredit(state: State): StoreCredit | undefined {
    const { locale, cart } = state
    const { paymentInstruction } = cart || {}
    const storeCreditPayment = paymentInstruction?.find(({ payMethodId }) => payMethodId === 'STORE_CREDIT')

    if (!storeCreditPayment) return

    const {
        piAmount,
        piAmount: { amount, divisor },
        piCurrency: { label },
    } = storeCreditPayment

    const price: Price = priceFromPriceObj(piAmount)

    return {
        amount,
        divisor,
        formattedAmount: formatPrice(price, label, locale?.id),
    }
}
